module.exports = __webpack_public_path__ + "img/machinery.7c90fa02.svg";